import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import { ApprovalEngineDetailRBACPage } from '../rbac/approvalDetail'
import { ApprovalEngineListRBACPage } from '../rbac/approvalList'

const ApprovalEngineList = lazy(() => import('../pages/ApprovalEngineList'))
const ApprovalEngineDetail = lazy(() => import('../pages/ApprovalEngineDetail'))

export const ApprovalEngineListRouter: RouterFeatureInterface<
  'ApprovalEngineListRouter',
  '/dashboard/approval-engine'
> = {
  name: 'ApprovalEngineListRouter',
  Component: ApprovalEngineList,
  path: '/dashboard/approval-engine',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: ApprovalEngineListRBACPage.pageID,
  isDashboard: true,
}

export const ApprovalEngineDetailRouter: RouterFeatureInterface<
  'ApprovalEngineDetailRouter',
  '/dashboard/approval-engine/:id'
> = {
  name: 'ApprovalEngineDetailRouter',
  Component: ApprovalEngineDetail,
  path: '/dashboard/approval-engine/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ApprovalEngineDetailRBACPage.pageID,
}

const ApprovalEngineRouter = [ApprovalEngineListRouter, ApprovalEngineDetailRouter]

export const ApprovalEngineRouterDetail = generateRouterDetail(ApprovalEngineRouter)

export default ApprovalEngineRouter
